import { withViewModel } from '~/hooks/useViewModel';
import AddToListDialog from './AddToListDialog';
import useAddToListDialog from './useAddToListDialog';

const AddToListDialogContainer = withViewModel(AddToListDialog, useAddToListDialog);

export default AddToListDialogContainer;
